<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="mt-1 mb-3">Lista das Notas Fiscais Tributada</h5>
            <Loader :loading="httpSend">
              <div v-if="guias && guias.length > 0">
              <h5 class="mt-1 mb-3">Duam: {{ guias[0].dam_codigo_v }}</h5>
              <div v-for="g in guias" :key="g.sep_codigo" class="row">
                <div class="col-md-12 mb-3 border-bottom border-dark">
                  <div class="row">
                    <div class="col-md-4">
                      <b-form-group label="N° da Nota">
                        <h6 class="mb-3">{{ g.not_numero }} <span v-show="g.soc_codigo"
                                                                  class="badge badge-danger font-size-12">Cancelada</span>
                        </h6>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group label="CPF/CNPJ Tomador">
                        <h6 class="mb-3" v-if="g.sep_cpf_cnpj_tomador.length < 12">
                          {{ g.sep_cpf_cnpj_tomador | VMask('###.###.###-##') }}</h6>
                        <h6 class="mb-3" v-else>{{ g.sep_cpf_cnpj_tomador | VMask('##.###.###/####-##') }}</h6>
                      </b-form-group>
                    </div>
                    <div class="col-md-5">
                      <b-form-group label="Nome/Razão Social">
                        <h6 class="mb-3">{{ g.sep_razao_social_tomador }}</h6>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <b-form-group label="Competência">
                        <h6 class="mb-3">{{ g.sep_competencia | formatDateCompetencia }}</h6>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group label="Valor da Nota">
                        <h6 class="mb-3">{{ g.sep_valor | formatNumeroBr }}</h6>
                      </b-form-group>
                    </div>
                    <div class="col-md-5">
                      <b-form-group label="Retido">
                        <h6 class="mb-3">{{ g.sep_iss_retido | s_NtoText }}</h6>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <b-form-group label="Valor ISS">
                        <h6 class="mb-3">{{ g.sep_iss | formatNumeroBr }}</h6>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group label="Imposto de Renda">
                        <h6 class="mb-3">{{ g.sep_ir | formatNumeroBr }}</h6>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group label="CPF/CNPJ Prestador">
                        <h6 class="mb-3" v-if="g.sep_cpf_cnpj_prestador.length < 12">
                          {{ g.sep_cpf_cnpj_prestador | VMask('###.###.###-##') }}</h6>
                        <h6 class="mb-3" v-else>{{ g.sep_cpf_cnpj_prestador | VMask('##.###.###/####-##') }}</h6>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </div>
              <button v-show="false" v-if="guias[0].tab_106situacao ==='963' || guias[0].tab_106situacao ==='964'"
                      type="button"
                      @click="baixarGuia" class="btn btn-label btn-primary">
                <i class="bx bx-download label-icon"></i>
                Baixar DUAM
              </button>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/router/layouts/main";
import Loader from "@/components/widgets/loader";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import {guiaDetalhe} from "@/api/financeiro/guia";
import {impressao} from "@/helps/impressao";
import {getFinanceiroGuia} from "@/api/relatorio/financeiro";

export default {
  page: {
    title: "DUAM Detalhe",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader
  },
  data() {
    return {
      title: "DUAM Detalhe",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'DUAM',
          active: true,
        },
      ],
      httpSend: false,
      guias: [],
    };
  },
  computed: {
    empresa: {
      get: function () {
        return this.$store.state.auth.currenEmpresa;
      },
    },
  },
  created() {
    this.getGuia();
  },
  methods: {
    getGuia() {
      this.httpSend = true;
      guiaDetalhe(this.$route.params.dam_hash).then(response => {
        if (response.status) {
          this.guias = response.dados;
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false;
      })
    },
    baixarGuia() {
      this.httpSend = true;
      impressao(getFinanceiroGuia(this.$route.params.dam_hash), 'P').catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
  }
};
</script>


